 $('.sld_reel').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: true,
    infinite: true,
    prevArrow: '<button class="slider-button slick-prev slick-arrow slider-button--prev"><svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.104786 7.44396C0.160267 7.58705 0.243458 7.71778 0.349585 7.82864L6.17811 13.6572C6.2868 13.7659 6.41583 13.8521 6.55784 13.9109C6.69985 13.9697 6.85206 14 7.00576 14C7.31619 14 7.61391 13.8767 7.83342 13.6572C7.9421 13.5485 8.02832 13.4195 8.08714 13.2774C8.14597 13.1354 8.17624 12.9832 8.17624 12.8295C8.17624 12.5191 8.05292 12.2214 7.83342 12.0019L3.98659 8.1667L12.8343 8.1667C13.1435 8.1667 13.44 8.04389 13.6586 7.82527C13.8772 7.60666 14 7.31016 14 7.00099C14 6.69183 13.8772 6.39533 13.6586 6.17672C13.44 5.9581 13.1435 5.83529 12.8343 5.83529L3.98659 5.83529L7.83342 2.00011C7.94268 1.89175 8.0294 1.76282 8.08858 1.62077C8.14776 1.47872 8.17823 1.32635 8.17823 1.17246C8.17823 1.01858 8.14776 0.866214 8.08858 0.724162C8.0294 0.58211 7.94268 0.453183 7.83342 0.344815C7.72505 0.235555 7.59612 0.148832 7.45407 0.0896496C7.31202 0.0304684 7.15965 3.55672e-07 7.00577 3.42219e-07C6.85188 3.28766e-07 6.69951 0.0304683 6.55746 0.0896495C6.41541 0.148832 6.28648 0.235555 6.17811 0.344815L0.349585 6.17334C0.243458 6.28421 0.160268 6.41493 0.104786 6.55803C-0.0118059 6.84183 -0.0118059 7.16016 0.104786 7.44396Z" fill="white"/></svg></button>',
    nextArrow: '<button class="slider-button slick-next slick-arrow slider-button--next"><svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.8952 6.55604C13.8397 6.41294 13.7565 6.28222 13.6504 6.17135L7.82189 0.342824C7.7132 0.234136 7.58417 0.147919 7.44216 0.0890975C7.30015 0.0302756 7.14794 0 6.99424 0C6.68381 0 6.38609 0.123318 6.16658 0.342824C6.0579 0.451513 5.97168 0.580545 5.91286 0.722554C5.85403 0.864563 5.82376 1.01677 5.82376 1.17048C5.82376 1.48091 5.94708 1.77862 6.16658 1.99813L10.0134 5.8333H1.16571C0.856541 5.8333 0.56004 5.95611 0.341428 6.17473C0.122815 6.39334 0 6.68984 0 6.99901C0 7.30817 0.122815 7.60467 0.341428 7.82328C0.56004 8.0419 0.856541 8.16471 1.16571 8.16471H10.0134L6.16658 11.9999C6.05732 12.1083 5.9706 12.2372 5.91142 12.3792C5.85224 12.5213 5.82177 12.6736 5.82177 12.8275C5.82177 12.9814 5.85224 13.1338 5.91142 13.2758C5.9706 13.4179 6.05732 13.5468 6.16658 13.6552C6.27495 13.7644 6.40388 13.8512 6.54593 13.9103C6.68798 13.9695 6.84035 14 6.99424 14C7.14812 14 7.30049 13.9695 7.44254 13.9103C7.58459 13.8512 7.71352 13.7644 7.82189 13.6552L13.6504 7.82666C13.7565 7.71579 13.8397 7.58507 13.8952 7.44197C14.0118 7.15817 14.0118 6.83984 13.8952 6.55604Z" fill="white"/></svg></button>',
    responsive: [
        {
          breakpoint: 1199,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 850,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 770,
          settings: {
            slidesToShow: 2,
            initialSlide: 1,
            centerMode: true,
            centerPadding: '50px',
            arrows: false
          }
        },
        {
          breakpoint: 570,
          settings: {
            slidesToShow: 1,
            initialSlide: 1,
            centerMode: true,
            centerPadding: '50px',
            arrows: false
          }
        }
      ]
  
  });